var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoGovBrColorido(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 495,
    height: 178,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#2864AE;}\r\n\t.st1{fill:#48AD45;}\r\n\t.st2{fill:#FABD14;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    id: "canvas_background",
    height: 180,
    width: 497,
    y: -1,
    x: -1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17695-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m53.424995,111.720003c11.77,0 21.15,-9.93 21.15,-24.63c0.91,-11.54 -7.7,-21.63 -19.24,-22.55c-0.63,-0.05 -1.27,-0.07 -1.91,-0.06c-12.3,0 -18.74,10.85 -18.74,23.9c-0.01,14.89 8.81,23.34 18.74,23.34zm53.12,14.15c0,39.33 -19.1,52.01 -57.71,52.01c-12.44,0.03 -24.81,-2.01 -36.58,-6.06l1.65,-26.11c9.93,5.37 21.07,8.09 32.36,7.91c19.12,0 29.41,-9 29.41,-27.75l0,-5.16l-0.37,0c-7.2,10.62 -19.35,16.8 -32.17,16.36c-26.29,0 -42.64,-19.84 -42.64,-48.17c0,-28.5 13.41,-49.81 43.19,-49.81c13.58,0.11 26.03,7.57 32.53,19.49l0.38,0l0,-17.26l29.95,0l0,84.54l0,0.01z",
    className: "st0",
    id: "Caminho_4108"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m239.934995,136.960003l36.81,0l34.61,-95.17l-32.15,0l-19.52,67.8l-0.36,0l-19.37,-67.8l-34.7,0l34.68,95.17z",
    className: "st1",
    id: "Caminho_4109"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m183.754995,89.400003c0,-14.24 -6.21,-26.84 -21.37,-26.84s-21.36,12.6 -21.36,26.84c0,14.06 6.21,26.66 21.36,26.66s21.37,-12.6 21.37,-26.66zm-76.69,0c0,-31.59 23.91,-49.83 55.32,-49.83s55.32,18.26 55.32,49.83c0,31.41 -23.91,49.66 -55.32,49.66s-55.32,-18.25 -55.32,-49.66z",
    className: "st2",
    id: "Caminho_4110"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.074995,123.510003c0,8.62 -6.99,15.6 -15.61,15.6c-8.62,0 -15.6,-6.99 -15.6,-15.61c0,-8.61 6.98,-15.59 15.6,-15.6c8.61,-0.01 15.6,6.97 15.61,15.58c0,0.01 0,0.02 0,0.03z",
    className: "st0",
    id: "Caminho_4111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.014995,64.840003c-12.05,0 -20.09,10.58 -20.09,24.83c0,13.88 9.14,24.3 20.09,24.3c12.42,0 19.91,-10.42 19.91,-25.58c0,-12.59 -7.12,-23.55 -19.91,-23.55zm-52.96,-64.84l33.07,0l0,54.07l0.37,0c7.91,-9.84 20.1,-15.22 32.7,-14.42c26.3,0 40.71,25.01 40.71,48.03c0,28.12 -15.15,51.51 -43.47,51.51c-13.7,0.53 -26.47,-6.96 -32.69,-19.18l-0.37,0l0,17l-30.34,0l0,-137l0.02,0l0,-0.01z",
    className: "st0",
    id: "Caminho_4112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.834995,68.130003c-3.64,-0.91 -7.39,-1.28 -11.14,-1.09c-15.34,0 -23.91,11.14 -23.91,29.77l0,40.19l-32.89,0l0,-95.21l29.98,0l0,17.54l0.37,0c4.15,-11.95 15.48,-19.89 28.12,-19.72c3.74,0.06 7.46,0.43 11.14,1.09l-1.67,27.43z",
    className: "st2",
    id: "Caminho_4113"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGovBrColorido);
export default __webpack_public_path__ + "static/media/logoGovBrColorido.6a6d79683c97bb125e93f03a266bd3c8.svg";
export { ForwardRef as ReactComponent };